const Condition = require( './Condition' );
const BattleCalc = require( '../BattleCalc' );

const BlockingCondition = function( instigator, owner, battleState, duration ) {
	const condition = new Condition( instigator, owner, battleState );
	condition.handle = 'blocking';
	condition.duration = duration;
	condition.ConditionClass = BlockingCondition;

	const extant = BattleCalc.getCondition( owner, 'blocking' );
	if( extant ) {
		battleState.expireCondition( extant.uid );
	}

	condition.initInterval( condition.expire, duration );
	if( battleState.paused ) {
		condition.intervalTimer.pause();
	}

	return condition;
};
module.exports = BlockingCondition

BlockingCondition.fromCopy = function(cState, owner, instigator, battleState) {
	const elapsed = Date.now() - cState.startTime;
	const remainingDuration = Math.max(0, cState.duration - elapsed);
	return BlockingCondition(instigator, owner, battleState, remainingDuration);
};
